import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { GraphPredictionStatistics } from "@/utilities/graphing/lib/graphdata";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";

@staticImplements<ResponseModelInterfaceStatic>()
export class CycleStatistics
{
    public constructor(
        public mean: number|null,
        public auc: number|null,
        public auc24: number|null,
        public cumulativeAuc: number|null,
        public residual: number|null,
        public peak: number|null,
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): CycleStatistics
    {
        const meanElement = elem.firstChildByTagOrNull("mean");
        const aucElement = elem.firstChildByTagOrNull("auc");
        const auc24Element = elem.firstChildByTagOrNull("auc24");
        const cumulativeAucElement = elem.firstChildByTagOrNull("cumulativeAuc");
        const residualElement = elem.firstChildByTagOrNull("residual");
        const peakElement = elem.firstChildByTagOrNull("peak");

        return new this(
            meanElement?.valueAsNumber() ?? null,
            aucElement?.valueAsNumber() ?? null,
            auc24Element?.valueAsNumber() ?? null,
            cumulativeAucElement?.valueAsNumber() ?? null,
            residualElement?.valueAsNumber() ?? null,
            peakElement?.valueAsNumber() ?? null,
        );
    }

    /**
     * Converts the current statistics into an object that can be stored in the graphdata structure.
     * This essentially only forwards the properties of this object, but doing this here allows to keep
     * graphdata self-contained to allow for potential future testings.
     */
    public toGraphPredictionStatistics(cycleStart: Date, cycleEnd: Date): GraphPredictionStatistics
    {
        const graphDataStats = new GraphPredictionStatistics();
        graphDataStats.mean = this.mean ?? -1;
        graphDataStats.auc = this.auc ?? -1;
        graphDataStats.auc24 = this.auc24 ?? -1;
        graphDataStats.cumulativeAuc = this.cumulativeAuc ?? -1;
        graphDataStats.residual = this.residual ?? -1;
        graphDataStats.peak = this.peak ?? -1;

        graphDataStats.cycleStart = cycleStart;
        graphDataStats.cycleEnd = cycleEnd;

        return graphDataStats;
    }
}
